/**
 * The four departments Leadership Requests can be filed against.
 *
 * A fixed set, not director-configurable reference data like projects and
 * categories (§20) — the department list and its colours were specified
 * explicitly rather than left open, so it is a constant here in the same
 * shape as `TASK_STATUS_META` / `TASK_PRIORITY_META`.
 */
export const DEPARTMENTS = ['APD', 'CCSO', 'GSP', 'CCFR'];
export function isDepartment(value) {
    return typeof value === 'string' && DEPARTMENTS.includes(value);
}
export const DEPARTMENT_META = {
    APD: { key: 'APD', label: 'APD', tone: 'dept-apd' },
    CCSO: { key: 'CCSO', label: 'CCSO', tone: 'dept-ccso' },
    GSP: { key: 'GSP', label: 'GSP', tone: 'dept-gsp' },
    CCFR: { key: 'CCFR', label: 'CCFR', tone: 'dept-ccfr' },
};
//# sourceMappingURL=departments.js.map